import { render, staticRenderFns } from "./HealthAndSocialDash.vue?vue&type=template&id=ad99f554"
import script from "./HealthAndSocialDash.vue?vue&type=script&lang=js"
export * from "./HealthAndSocialDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports